// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { useAppLogging as useAppLoggingCore } from "@hex-insights/app-modules";
import * as Log from "@hex-insights/log";
import { appName, appVersion, instanceID, projectName } from "./settings";

export function configureLogging() {
	Log.setFields({ instanceID });

	const logAPIRegion = process.env.REACT_APP_LOG_API_REGION ?? "";
	const logBaseURL = Log.API.regionalURLs[logAPIRegion];
	if (logBaseURL) {
		Log.setOutput(new Log.APIWriter(logBaseURL + Log.API.paths.log));
	}

	const levelName = process.env.REACT_APP_LOG_LEVEL ?? "";
	if (levelName !== "") {
		const level = Log.Level.fromName(levelName);
		if (level === null) {
			Log.warn(`Log level '${levelName}' is not supported, using default`);
		} else {
			Log.setLevel(level);
		}
	}
}

const initializeFields = {
	project: projectName,
	domain: "frontend",
	app: appName,
	appVersion,
	env: process.env.REACT_APP_ENV,
};

export function useAppLogging() {
	useAppLoggingCore({ initializeFields });
}
